// extracted by mini-css-extract-plugin
export var button = "_6a-4";
export var hasDarkBackground = "_6a-7";
export var hasLightBackground = "_6a-6";
export var iconWrapper = "_6a-0";
export var large = "_6a-2";
export var medium = "_6a-1";
export var small = "_6a-5";
export var xsmall = "_6a-3";